import phoneNumberInputHelper from "../../../../../../common/components/form/input/phone-number/phone-number-input.helper";
import formValidationService from "../../../../../../common/utils/validation/form-validation.service";
import PassengerAddByCargoFormData from "./types/passenger-add-by-cargo-form-data";
import PassengerAddByCargoFormValidationResults from "./types/passenger-add-by-cargo-form-validation.results";

const getDefaultFormData = (): PassengerAddByCargoFormData => {
  return {
    firstName: "",
    lastName: "",
    mobile: phoneNumberInputHelper.getEmptyValue(),
    alternativeMobile: phoneNumberInputHelper.getEmptyValue(),
    email: "",
    username: "",
    password: "",
    passwordRepeat: "",
    addresses: [],
    dispatches: [],
  };
};

const getFormValidationResults =
  (): PassengerAddByCargoFormValidationResults => {
    return {
      firstName: formValidationService.defaultValidationResult,
      lastName: formValidationService.defaultValidationResult,
      username: formValidationService.defaultValidationResult,
      mobile: formValidationService.defaultValidationResult,
      alternativeMobile: formValidationService.defaultValidationResult,
      email: formValidationService.defaultValidationResult,
      password: formValidationService.defaultValidationResult,
      passwordRepeat: formValidationService.defaultValidationResult,
      addresses: formValidationService.defaultValidationResult,
      dispatches: formValidationService.defaultValidationResult,
    };
  };

const passengerAddByCargoFormHelper = {
  getDefaultFormData,
  getFormValidationResults,
};

export default passengerAddByCargoFormHelper;
